import type { Theme } from '@mui/material/styles';

/**
 * Dialogs use the medium radius from the design system. Full-screen dialogs keep square
 * edges (MUI sets their radius to 0), so the rounding is only applied to floating dialogs.
 */
export const muiDialogStyleOverrides = {
	paper: ({ theme, ownerState }: { theme: Theme; ownerState: { fullScreen?: boolean } }) =>
		ownerState.fullScreen ? {} : { borderRadius: theme.shape['radius-md'] }
};
